export class ImmigrationStatusTypes {
    static readonly DRAFT = 'ImmDraft';
    static readonly PENDING ='ImmPending';
    static readonly ACCEPTED = 'ImmAccepted';
    static readonly DECLINED = 'ImmDeclined';
    static readonly INPROCESS = 'ImmInProcess';
    static readonly APPROVED = 'ImmApproved';
    static readonly REJECTED = 'ImmRejected';
    static readonly COMPLETED = 'ImmCompleted';
  static readonly ONHOLD = 'ImmOnHold';
  static readonly WITHDRAWN = 'ImmWithdrawn';
}
